import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';
import { combineLatest, map, Observable, tap } from 'rxjs';

import { IAuroraState } from '@apps/aurora.state';
import { FilterTag, NoneTag, AnyTag, StaticFilterTag } from '@apps/cmdb/models';
import * as fromCmdbStore from '@apps/cmdb/store';
import * as fromRootStore from '@apps/root/store';

@Component({
    selector: 'aa-filter-tag',
    templateUrl: './filter-tag.component.html',
    styleUrls: [
        './filter-tag.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterTagComponent implements OnInit
{
    public filterTags: Observable<FilterTag[]>;
    public availableTags: Observable<FilterTag[]>;
    public isEmptyTagList = true;

    constructor (
        private store: Store<IAuroraState>
    )
    {
    }

    ngOnInit (): void
    {
        this.filterTags = this.store.select(fromRootStore.getFilterTags)
            .pipe(
                tap((filterTags: FilterTag[]): void =>
                {
                    this.isEmptyTagList = filterTags.length === 0;
                })
            );

        this.availableTags = combineLatest([
            this.store.select(fromCmdbStore.getAllTags),
            this.store.select(fromRootStore.getFilterTags)
        ])
            .pipe(
                map(([tags, filterTags]): FilterTag[] =>
                {
                    const allTags = [new NoneTag(), new AnyTag()]
                        .concat(
                            tags
                                .map(StaticFilterTag.mapperFromTag)
                        );

                    return allTags.filter((tag: FilterTag) =>
                        filterTags.every((filterTag: FilterTag) =>
                            filterTag.tagId !== tag.tagId
                        )
                    );
                })
            );
    }

    onUnselectTag (filterTag: FilterTag): void
    {
        this.store.dispatch(fromRootStore.RootFilterTagActions.RootFilterTagUnselect({ filterTag }));
    }

    onSelectTag (filterTag: FilterTag): void
    {
        this.store.dispatch(fromRootStore.RootFilterTagActions.RootFilterTagSelect({ filterTag }));
    }

    onToggleIncludedTag (filterTag: FilterTag): void
    {
        this.store.dispatch(fromRootStore.RootFilterTagActions.RootFilterTagToggleIncluded({ filterTag, toggle: !filterTag.included }));
    }

    onToggleEnabledTag (filterTag: FilterTag): void
    {
        this.store.dispatch(fromRootStore.RootFilterTagActions.RootFilterTagToggleEnabled({ filterTag, toggle: !filterTag.enabled }));
    }

    onClearAll (): void
    {
        this.store.dispatch(fromRootStore.RootFilterTagActions.RootFilterTagReset());
    }

}
